import { render, staticRenderFns } from "./ContactPreferencesCard.vue?vue&type=template&id=43390d91"
import script from "./ContactPreferencesCard.vue?vue&type=script&lang=js"
export * from "./ContactPreferencesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports